module.exports = __webpack_public_path__ + "static/media/teamIcon.857ffaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamIcon.png
// module id = 142
// module chunks = 0